import { FC } from 'react';
import {
  ColumnLayout,
  Flashbar,
  SpaceBetween,
  Table
} from '@awsui/components-react';
import Moment from 'react-moment';

import { FlashbarProps } from '@awsui/components-react';

import ValueWithLabel from '../../../../common/ValueWithLabel';
import { IUserReactivationRequest } from '../../../../../interfaces/domain/userReactivationRequest';

interface ViewProps {
  userReactivationRequest: IUserReactivationRequest;
  flashBarItems: FlashbarProps.MessageDefinition[];
}

const View: FC<ViewProps> = ({ userReactivationRequest, flashBarItems }) => {
  const tableColumnDefinitions = [
    {
      id: 'attribute',
      header: 'Attribute',
      cell: (item: any) => item.name
    },
    {
      id: 'value',
      header: 'Value',
      cell: (item: any) => item.value
    }
  ];

  const tableItems = [
    {
      name: 'UUID',
      value: userReactivationRequest.uuid || '-'
    },
    {
      name: 'First Name',
      value: userReactivationRequest.firstName || '-'
    },
    {
      name: 'Last Name',
      value: userReactivationRequest.lastName || '-'
    },
    {
      name: 'Corp Email',
      value: userReactivationRequest.corpEmail || '-'
    },
    {
      name: 'Rejection Reason',
      value: userReactivationRequest.rejectionReason || '-'
    },
    {
      name: 'Justification',
      value: userReactivationRequest.justification || '-'
    },
    {
      name: 'Deprecated',
      value: userReactivationRequest.deprecated.toString() || '-'
    },
    {
      name: 'Created At',
      value: (
        <Moment unix local format="LLLL">
          {userReactivationRequest.createdAt || '-'}
        </Moment>
      )
    },
    {
      name: 'Updated At',
      value: (
        <Moment unix local format="LLLL">
          {userReactivationRequest.updatedAt || '-'}
        </Moment>
      )
    },
    {
      name: 'Updated By',
      value: userReactivationRequest.updatedBy || '-'
    }
  ];

  return (
    <SpaceBetween size="xs">
      <Flashbar items={flashBarItems} />
      <SpaceBetween size="l">
        <ColumnLayout columns={3} variant="text-grid">
          <ValueWithLabel label="User Name">
            {userReactivationRequest.userName || '-'}
          </ValueWithLabel>
          <ValueWithLabel label="Request Status">
            {userReactivationRequest.requestStatus || '-'}
          </ValueWithLabel>
        </ColumnLayout>

        <Table columnDefinitions={tableColumnDefinitions} items={tableItems} />
      </SpaceBetween>
    </SpaceBetween>
  );
};
export default View;
